import { useAppContext } from "../../../../_context";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FormSection from "./FormSection";

const SignupFullForm = ({ setMessageSent }) => {
  const [{ tx }] = useAppContext();

  return (
    <>
      <section className="title-section">
        <Container>
          <Row>
            <Col md={8} lg={5} className="mx-auto text-center">
              <h1>{tx["Become a coach or sparring partner"]}</h1>
              <p>{tx["Please fill in all the details below"]}</p>
            </Col>
          </Row>
        </Container>
      </section>
      <FormSection setMessageSent={setMessageSent} />
    </>
  );
};

export default SignupFullForm;
